import { PointsTable } from '@/features/scoring/ui/PointsTable';

/**
 * §5: a page composes, it does not implement.
 */
export function PointsPage() {
  return <PointsTable />;
}
